module.exports = __webpack_public_path__ + "static/media/iconfont.ad53a68e.svg";